import { Modal, Collapse, Skeleton } from "antd";
import Title from "antd/es/typography/Title";
import { useBuscarAptoEmpreend } from "../hooks/useBuscarAptoEmpreend";
import { Apartamento } from "../../../interfaces/Apartamento";

const { Panel } = Collapse;

export default function ModalAptoInfo({
  isModalOpen,
  handleFechar,
  empreendId,
}: any) {
  const { aptos, isLoading } = useBuscarAptoEmpreend(isModalOpen, empreendId);

  const items =
    aptos && aptos.length > 0
      ? aptos.map((apto: Apartamento) => ({
          key: apto.id,
          label: apto.nome,
          children: (
            <div>
              <p>
                <strong>Quartos:</strong> {apto.quartos}
              </p>
              <p>
                <strong>Banheiros:</strong> {apto.banheiros}
              </p>
              <p>
                <strong>Capacidade:</strong> {apto.capacidade} pessoas
              </p>
              <p>
                <strong>Metragem:</strong> {apto.metragem} m²
              </p>
              <p>
                <strong>Estacionamento:</strong>{" "}
                {apto.estacionamento ? "Sim" : "Não"}
              </p>
              <p>
                <strong>Varanda:</strong> {apto.varanda ? "Sim" : "Não"}
              </p>
              <p>
                <strong>Térreo:</strong> {apto.terreo ? "Sim" : "Não"}
              </p>
              <p>
                <strong>Criado em:</strong>{" "}
                {apto.created_at
                  ? new Date(apto.created_at).toLocaleDateString()
                  : "Não informado"}
              </p>
            </div>
          ),
        }))
      : [
          {
            key: "vazio",
            label: "Sem apartamentos",
            children: (
              <div>Este Empreendimento não possui apartamentos vinculados</div>
            ),
          },
        ];

  return (
    <>
      {isLoading && <Skeleton active />}
      {!isLoading && (
        <Modal
          open={isModalOpen}
          onCancel={handleFechar}
          footer={null}
          width={500}
        >
          <Title level={3}>Apartamentos</Title>

          <Collapse accordion items={items} />
        </Modal>
      )}
    </>
  );
}
